import IninBase from './IninBase';

const xml2js = require('xml2js');

export default class IninIPC extends IninBase {
    constructor(...args) {
        super(...args)
        this.playing = false
        this.repeat = false
        this.stepMode = false
        this.stepsData = []
        this.currentStepIndex = 0
    }

    addListeners() {
        this.cortona.on("app.didFinishLoadDocument", () => this.didFinishLoadDocument())
    }

    addListenersAfter() {
        this.cortona.on("app.procedure.didEnterSubstepWithName", substepId => {
            let stepId = this.cortona.app.procedure.interactivity.getProcedureItemInfo(
                substepId
            ).parentStep
            this.currentStepIndex = this.stepsData.findIndex(
                stepData => stepData.step === stepId
            )
            this.emit("currentStepNum", this.getCurrentStepNum())
            this.emit("currentStepId", this.getCurrentStepId())
            this.emit("numOfSteps", this.getNumOfSteps())
        })
        this.cortona.on("touch.didPointerDown", (x, y) => {
            if (this.playing) {
                this.cortona.app.procedure.pause()
            } else {
                this.resumePossible = { x, y }
                setTimeout(() => (this.resumePossible = false), 500)
            }
        })
        this.cortona.on("touch.didPointerUp", (x, y) => {
            if (
                !this.playing &&
                this.resumePossible &&
                this.resumePossible.x == x &&
                this.resumePossible.y == y
            ) {
                this.resumePossible = false
                this.cortona.app.procedure.play()
            }
        })
        this.cortona.on("app.procedure.didChangePlayerState", (time, flags) => {
            let wasPlaying = this.playing
            this.playing = flags & 1
            if (
                this.stepMode &&
                this.repeat &&
                this.cortona.app.procedure.getPlayableRangeStopTime() <= time &&
                wasPlaying &&
                !this.playing
            ) { window.setTimeout(() => this.cortona.app.procedure.play(), 10) }

            this.emit("time", time)
            this.emit("playing", !!this.playing)
        })
    }

    didFinishLoadDocument() {
        this.getStepsData()
        // this.enableStepMode()
        this.dispatchEvents();
        this.addListenersAfter();
        this.prepareStepList();
        if (this.cortonaFrame) this.external.showFrame();
    }

    async parseXml(value) {
        var parser = new xml2js.Parser()
        return await new Promise((resolve, reject) => {
            parser.parseString(value, function (err, result) {
                if (err) reject(err)
                else resolve(result)
            })
        })
    }

    async prepareStepList() {
        console.log("cortona procedure", this.cortona.app.procedure)
        let xml = this.cortona.app.procedure.interactivity.json.SimulationInteractivity["DocumentTemplate"]["#text"]
        if (xml) {
            let json = await this.parseXml(xml)
            let steps = json.div.div[0].ol[0].li.map(li => ({
                id: li.span[0].span[0].$["data-key"],
                text: li.span[0]._,
                warn: li.div && li.div[0].div[1]._
            }))
            this.emit("stepList", steps)
        } else {
            console.log("no steps xml")
        }
    }

    dispatchEvents() {
        this.notifyRangeChanged()
        this.emit("stepMode", this.isStepModeEnabled())
        this.emit("repeat", this.isRepeatEnabled())
        this.emit("currentStepNum", this.getCurrentStepNum())
        this.emit("currentStepId", this.getCurrentStepId())
        this.emit("numOfSteps", this.getNumOfSteps())
        this.emit("rangeEnd", this.getEndTime())
        this.emit("rangeStart", this.getStartTime())
        this.emit("marks", this.getTickMarks())
        this.cortona.app.procedure.requestPlayerState()
    }

    switchPlaying() {
        if (this.playing) this.cortona.app.procedure.pause()
        else this.cortona.app.procedure.play()
    }

    activityInterrupted() {
        if (this.playing) {
            this.activityInterruptedPause = true
            this.cortona.app.procedure.pause()
        }
    }

    activityRestored() {
        if (this.activityInterruptedPause) {
            this.activityInterruptedPause = false
            this.cortona.app.procedure.play()
        }
    }

    seekTime(time) {
        this.cortona.app.procedure.setPlayPosition(time, false)
        this.cortona.app.procedure.requestPlayerState()
    }

    switchStepMode() {
        this.stepMode ? this.disableStepMode() : this.enableStepMode()
        this.emit("stepMode", this.stepMode)
    }

    enableStepMode() {
        this.stepMode = true
        this.stepRoll(0)
    }

    disableStepMode() {
        this.stepMode = false
        this.cortona.app.procedure.setPlayRange()
        this.notifyRangeChanged()
    }

    isStepModeEnabled() {
        return this.stepMode
    }

    switchRepeat() {
        this.repeat ? this.disableRepeat() : this.enableRepeat()
        this.emit("repeat", this.repeat)
    }

    enableRepeat() {
        if (this.stepMode) this.repeat = true
    }

    disableRepeat() {
        this.repeat = false
    }

    isRepeatEnabled() {
        return this.repeat
    }

    getStepsData() {
        let stepIds = this.cortona.app.procedure.interactivity.getProcedureItemInfo(
            this.cortona.app.procedure.interactivity.getProcedureId()
        ).children
        this.stepsData = []
        for (var i = stepIds.length - 1; i >= 0; --i) {
            let step = stepIds[i]
            this.cortona.app.procedure.setPlayRange(step)
            this.stepsData.unshift({
                step: step,
                start: this.cortona.app.procedure.getPlayableRangeStartTime(),
                stop: this.cortona.app.procedure.getPlayableRangeStopTime()
            })
        }
        this.cortona.app.procedure.setPlayRange()
        this.cortona.app.procedure.seekToSubstep(this.stepsData[0].step)
    }

    mod(n, m) {
        return ((n % m) + m) % m
    }

    stepRoll(indexOffset) {
        let stepChanged = indexOffset != 0
        // let wasPlaying = this.playing
        let chosenIndex = this.currentStepIndex + indexOffset
        let correctedIndex = this.mod(chosenIndex, this.stepsData.length)
        let chosenStepData = this.stepsData[correctedIndex].step
        if (stepChanged) this.cortona.app.procedure.seekToSubstep(chosenStepData)
        this.cortona.app.procedure.setPlayRange(chosenStepData)
        this.notifyRangeChanged()
        if (stepChanged) this.cortona.app.procedure.play()
    }

    previousStep() {
        this.stepRoll(-1)
    }

    nextStep() {
        this.stepRoll(1)
    }

    goToStep(id) {
        this.cortona.app.procedure.seekToSubstep(id)
        if (this.stepMode) {
            this.cortona.app.procedure.setPlayRange(id)
            this.notifyRangeChanged()
        }
        this.cortona.app.procedure.play()
    }

    notifyRangeChanged() {
        this.emit("rangeEnd", this.cortona.app.procedure.getPlayableRangeStopTime())
        this.emit("rangeStart", this.cortona.app.procedure.getPlayableRangeStartTime())
        this.cortona.app.procedure.requestPlayerState()
    }


    getTickMarks() {
        return this.stepsData.map(s => s.start)
    }

    getCurrentStepNum() {
        return this.currentStepIndex + 1
    }

    getCurrentStepId() {
        return this.stepsData[this.currentStepIndex]?.step
    }

    getNumOfSteps() {
        return this.stepsData.length
    }

    getStartTime() {
        return this.cortona.app.procedure.getPlayableRangeStartTime()
    }

    getEndTime() {
        return this.cortona.app.procedure.getPlayableRangeStopTime()
    }

}